(function () {
  function initialize() {
    var surface = document.getElementById('rtp-main-img-wrap');
    var image = document.getElementById('rtp-main-img');
    var lightbox = document.getElementById('rtp-lightbox');
    var thumbs = Array.from(document.querySelectorAll('.rtp__thumb'));
    if (!surface || !image || !lightbox || surface.dataset.swipeReady) return;
    surface.dataset.swipeReady = 'true';
    surface.dataset.swipeMode = 'drag';
    surface.dataset.swipeVersion = 'touch-v2';
    surface.tabIndex = 0;
    surface.setAttribute('role', 'button');
    surface.setAttribute('aria-label', lightbox.getAttribute('aria-label'));
    image.draggable = false;
    var start = null, layer = null, rail = null, animation = null;
    var suppressClick = false, offset = 0, width = 0, baseIndex = 0;
    var originalVisibility = image.style.visibility;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var staged = null, frame = 0, warmFrame = 0, version = 0;
    var internalSelection = false;
    var observedSource = image.src;
    var pendingTarget = null;

    function index() {
      var currentPath = new URL(image.src, location.href).pathname;
      var active = thumbs.findIndex(function (thumb) { return thumb.classList.contains('active'); });
      if (active >= 0 && new URL(thumbs[active].dataset.src, location.href).pathname === currentPath) return active;
      var current = thumbs.findIndex(function (thumb) { return new URL(thumb.dataset.src, location.href).pathname === currentPath; });
      return Math.max(0, current >= 0 ? current : active);
    }
    function preload() {
      if (warmFrame) cancelAnimationFrame(warmFrame);
      warmFrame = requestAnimationFrame(function () {
        warmFrame = 0;
        if (!layer && thumbs.length > 1 && (!staged || staged.source !== image.src)) staged = build();
      });
    }
    function reset() {
      version++;
      if (frame) { cancelAnimationFrame(frame); frame = 0; }
      if (animation) { animation.cancel(); animation = null; }
      if (layer) {
        layer.remove();
        if (baseIndex === index()) staged = { layer: layer, rail: rail, baseIndex: baseIndex, source: image.src };
      }
      image.style.visibility = originalVisibility;
      layer = rail = null;
      pendingTarget = null;
      start = null;
      offset = 0;
      preload();
    }
    function select(i) {
      if (!thumbs[i]) return;
      thumbs[i].click();
      var track = thumbs[i].parentElement;
      var rect = thumbs[i].getBoundingClientRect();
      var trackRect = track.getBoundingClientRect();
      if (rect.left < trackRect.left) track.scrollLeft += rect.left - trackRect.left;
      else if (rect.right > trackRect.right) track.scrollLeft += rect.right - trackRect.right;
    }
    function build() {
      var current = index();
      var viewport = document.createElement('div');
      viewport.className = 'rtp__swipe-viewport';
      viewport.setAttribute('aria-hidden', 'true');
      viewport.style.cssText = 'position:absolute;inset:0;overflow:hidden;pointer-events:none;z-index:0;contain:paint;';
      var track = document.createElement('div');
      track.className = 'rtp__swipe-rail';
      track.style.cssText = 'position:absolute;inset:0;will-change:transform;transform:translate3d(0,0,0);transition:none;';
      for (var i = current - 1; i <= current + 1; i++) {
        if (!thumbs[i]) continue;
        var slide = image.cloneNode(false);
        slide.removeAttribute('id');
        slide.removeAttribute('srcset');
        slide.alt = '';
        slide.loading = 'eager';
        slide.decoding = 'async';
        slide.dataset.galleryIndex = String(i);
        slide.src = i === current ? image.src : thumbs[i].dataset.src;
        slide.style.cssText = 'position:absolute;top:0;left:' + ((i - current) * 100) + '%;width:100%;height:100%;max-width:none;visibility:visible;pointer-events:none;transition:none;';
        track.appendChild(slide);
        if (slide.decode) slide.decode().catch(function () {});
      }
      viewport.appendChild(track);
      return { layer: viewport, rail: track, baseIndex: current, source: image.src };
    }
    function prepare() {
      if (layer) return;
      var ready = staged && staged.source === image.src ? staged : build();
      staged = null;
      layer = ready.layer;
      rail = ready.rail;
      baseIndex = ready.baseIndex;
      rail.style.transform = 'translate3d(0,0,0)';
      surface.insertBefore(layer, surface.firstChild);
      originalVisibility = image.style.visibility;
      image.style.visibility = 'hidden';
    }
    function draw(value) {
      var edge = (baseIndex === 0 && value > 0) || (baseIndex === thumbs.length - 1 && value < 0);
      offset = edge ? value * 0.28 / (1 + Math.abs(value) / width) : Math.max(-width, Math.min(width, value));
      if (!frame) frame = requestAnimationFrame(paint);
    }
    function paint() {
      frame = 0;
      if (rail) rail.style.transform = 'translate3d(' + offset + 'px,0,0)';
    }
    function settle(direction, velocity) {
      if (!layer) return;
      var targetIndex = Math.max(0, Math.min(baseIndex + direction, thumbs.length - 1));
      pendingTarget = targetIndex;
      var target = (baseIndex - targetIndex) * width;
      var settlingVersion = ++version;
      if (frame) { cancelAnimationFrame(frame); paint(); }
      start = null;
      function finish() {
        var destination = rail && rail.querySelector('[data-gallery-index="' + targetIndex + '"]');
        var decoded = destination && destination.decode ? destination.decode().catch(function () {}) : Promise.resolve();
        decoded.then(function () {
          if (version !== settlingVersion) return;
          internalSelection = true;
          select(targetIndex);
          internalSelection = false;
          observedSource = image.src;
          var mainDecoded = image.decode ? image.decode().catch(function () {}) : Promise.resolve();
          mainDecoded.then(function () {
            requestAnimationFrame(function () { if (version === settlingVersion) reset(); });
          });
        });
      }
      var incoming = rail.querySelector('[data-gallery-index="' + targetIndex + '"]');
      if (targetIndex !== baseIndex && incoming && (!incoming.complete || !incoming.naturalWidth)) {
        incoming.decode().then(function () {
          if (version === settlingVersion) settle(direction, velocity);
        }, function () {
          if (version === settlingVersion) settle(0, 0);
        });
        return;
      }
      if (reducedMotion.matches || Math.abs(target - offset) < 1) { finish(); return; }
      var duration = Math.max(190, Math.min(290, 190 + 100 * Math.abs(target - offset) / width - Math.min(50, Math.abs(velocity || 0) * 25)));
      var settling = rail.animate([
        { transform: 'translate3d(' + offset + 'px,0,0)' },
        { transform: 'translate3d(' + target + 'px,0,0)' }
      ], { duration: duration, easing: 'cubic-bezier(.25,.8,.25,1)', fill: 'forwards' });
      animation = settling;
      settling.finished.then(function () { if (animation === settling) finish(); }, function () {});
    }
    function begin(event) {
      if (!event.isPrimary) { reset(); return; }
      if ((event.pointerType === 'mouse' && event.button !== 0) || thumbs.length < 2 || (window.visualViewport && window.visualViewport.scale > 1.05)) return;
      suppressClick = false;
      version++;
      width = surface.getBoundingClientRect().width;
      if (animation) {
        offset = new DOMMatrixReadOnly(getComputedStyle(rail).transform).m41;
        animation.cancel();
        animation = null;
        rail.style.transform = 'translate3d(' + offset + 'px,0,0)';
      }
      // A new swipe starts from the image already chosen by the previous release.
      // Recenter without changing the visible position, so rapid swipes are not swallowed.
      var rebased = layer && pendingTarget !== null && pendingTarget !== baseIndex;
      if (rebased) {
        var previousBase = baseIndex;
        internalSelection = true;
        select(pendingTarget);
        internalSelection = false;
        observedSource = image.src;
        var next = build();
        layer.remove();
        layer = next.layer;
        rail = next.rail;
        baseIndex = next.baseIndex;
        staged = null;
        offset += (baseIndex - previousBase) * width;
        rail.style.transform = 'translate3d(' + offset + 'px,0,0)';
        surface.insertBefore(layer, surface.firstChild);
      }
      pendingTarget = null;
      var edge = layer && ((baseIndex === 0 && offset > 0) || (baseIndex === thumbs.length - 1 && offset < 0));
      var origin = edge ? offset / Math.max(0.01, 0.28 - Math.abs(offset) / width) : offset;
      start = { id: event.pointerId, x: event.clientX, y: event.clientY, origin: origin, peak: offset, rebased: rebased, locked: false, samples: [{ x: event.clientX, time: event.timeStamp }] };
      if (event.pointerType !== 'touch') surface.setPointerCapture(event.pointerId);
    }
    function move(event) {
      if (!start || start.id !== event.pointerId) return;
      var dx = event.clientX - start.x;
      var dy = event.clientY - start.y;
      if (!start.locked) {
        if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { reset(); return; }
        if (Math.abs(dx) < 6 || Math.abs(dx) <= Math.abs(dy) * 1.15) return;
        prepare();
        start.locked = true;
      }
      suppressClick = true;
      start.samples.push({ x: event.clientX, time: event.timeStamp });
      // Keep a preceding point even when the browser batches a short flick into one move.
      while (start.samples.length > 2 && event.timeStamp - start.samples[1].time > 100) start.samples.shift();
      draw(start.origin + dx);
      if (Math.sign(offset) !== Math.sign(start.peak) || Math.abs(offset) > Math.abs(start.peak)) start.peak = offset;
    }
    function end(event) {
      if (!start || start.id !== event.pointerId) return;
      if (!start.locked) { start = null; if (layer) settle(0, 0); return; }
      var sample = start.samples[0];
      var velocity = sample ? (event.clientX - sample.x) / Math.max(1, event.timeStamp - sample.time) : 0;
      var displacement = start.rebased ? event.clientX - start.x : offset;
      var sign = Math.sign(displacement);
      var commit = Math.abs(displacement) >= Math.min(48, width * 0.12) || (Math.abs(displacement) > 18 && velocity * sign > 0.35);
      if (!start.rebased && Math.abs(start.peak) - Math.abs(offset) > 24 && velocity * sign < -0.45) commit = false;
      suppressClick = true;
      settle(commit ? -sign : 0, velocity);
    }
    surface.addEventListener('pointerdown', function (event) { if (event.pointerType !== 'touch') begin(event); });
    surface.addEventListener('pointermove', function (event) { if (event.pointerType !== 'touch') move(event); });
    surface.addEventListener('pointerup', function (event) { if (event.pointerType !== 'touch') end(event); });
    surface.addEventListener('pointercancel', function (event) { if (event.pointerType !== 'touch') reset(); });
    surface.addEventListener('lostpointercapture', function (event) { if (event.pointerType !== 'touch' && start) reset(); });
    function touchPoint(event, touch) {
      return { pointerId: touch.identifier, pointerType: 'touch', isPrimary: true,
        clientX: touch.clientX, clientY: touch.clientY, timeStamp: event.timeStamp };
    }
    surface.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) { reset(); return; }
      begin(touchPoint(event, event.touches[0]));
    }, { passive: true });
    surface.addEventListener('touchmove', function (event) {
      if (event.touches.length !== 1) { reset(); return; }
      move(touchPoint(event, event.touches[0]));
      if (start && start.locked && event.cancelable) event.preventDefault();
    }, { passive: false });
    surface.addEventListener('touchend', function (event) {
      if (!start) return;
      var touch = Array.from(event.changedTouches).find(function (point) { return point.identifier === start.id; });
      if (touch) end(touchPoint(event, touch));
    }, { passive: true });
    surface.addEventListener('touchcancel', reset, { passive: true });
    surface.addEventListener('click', function (event) {
      if (!suppressClick && !layer) return;
      suppressClick = false;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
    surface.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        reset();
        select(Math.max(0, Math.min(index() + (event.key === 'ArrowRight' ? 1 : -1), thumbs.length - 1)));
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        reset();
        suppressClick = false;
        surface.click();
      }
    });
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { if (!internalSelection) reset(); }, true); });
    new MutationObserver(function () {
      if (image.src !== observedSource) { observedSource = image.src; staged = null; reset(); }
      preload();
    }).observe(image, { attributes: true, attributeFilter: ['src', 'srcset'] });
    var measuredWidth = 0;
    new ResizeObserver(function (entries) {
      var nextWidth = entries[0].contentRect.width;
      if (measuredWidth && Math.abs(nextWidth - measuredWidth) > 1) reset();
      measuredWidth = nextWidth;
    }).observe(surface);
    preload();
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
